import protoRoot from "../proto-root";
import DataBuildInformation from "./DataBuildInformation";
import SupportedFeatures from "./SupportedFeatures";
import CameraInfo from "../private/CameraInfo";

function create({ numberOfCameras, availableCameras, selectedCameraId }) {
  const DataSenderStationConfiguration = protoRoot.lookupType(
    "comm.DataSenderStationConfiguration"
  );

  const senderStationConfiguration = DataSenderStationConfiguration.create({
    numberOfCameras,
    availableCameras: availableCameras.map((camera) => {
      return CameraInfo.create({
        cameraId: camera.deviceId,
        cameraName: camera.label
      });
    }),
    selectedCameraId,
    versionInfo: DataBuildInformation.create(),
    supportedFeatures: SupportedFeatures.create({ stationType: "baby" })
  });
  return senderStationConfiguration;
}

export default {
  create
};

// message DataSenderStationConfiguration {
//     bool hasCamera = 1;

//     DataBuildInformation versionInfo = 100;
//     repeated SupportedFeaturesType supportedFeatures = 101;
// }
